import React from 'react'
import PropTypes from 'prop-types'

import BoxRounded from '../../commons/BoxRounded/BoxRounded'
import Flex from '../../commons/Flex/Flex'
import Text from '../../commons/Text/Text'
import Place from '../../commons/Icons/Place'
import styles from './detailStore.module.scss'

const DetailStoreAddress = ({
  addressCity,
  addressNumber,
  addressPostalCode,
  addressStreet,
  addressUf
}) => {
  return (
    <BoxRounded>
      <Flex>
        <div className={styles.icon}>
          <Place />
        </div>
      </Flex>
      <Flex column>
        <Text size="sm" color="gray" variation="dark" bold margin="18px 0 11px">
          Endereço
        </Text>
        <Text color="gray" variation="dark" font="custom" size="xxs">
          {addressStreet}, {addressNumber}
          {`, CEP ${addressPostalCode}, `}
          {addressCity}, {addressUf}
        </Text>
      </Flex>
    </BoxRounded>
  )
}

DetailStoreAddress.defaultProps = {
  addressCity: null,
  addressNumber: null,
  addressPostalCode: null,
  addressStreet: null,
  addressUf: null
}

DetailStoreAddress.propTypes = {
  addressCity: PropTypes.string,
  addressNumber: PropTypes.string,
  addressPostalCode: PropTypes.string,
  addressStreet: PropTypes.string,
  addressUf: PropTypes.string
}

export default DetailStoreAddress
